import React from "react";
import { Text } from "@atoms";
import { AppLink } from "@base";
import { useCommunityData } from "@staticQueries";

const CommunityHome = () => {
  const { heading, content, relatedProjects } = useCommunityData();

  if (!heading && !content && !relatedProjects.length) {
    return null;
  }

  return (
    <div className="bg-black bg-opacity-55 text-center py-8 px-4 w-full max-w-screen-lg mx-auto border border-yellow">
      <div className="flex flex-col w-full max-w-screen-md mx-auto">
        {heading && (
          <Text
            variant="h5"
            className="text-yellow font-serif font-bold text-2xl md:text-4xl"
          >
            {heading}
          </Text>
        )}
        {content && (
          <Text className="text-offwhite font-serif my-6 leading-snug whitespace-pre-line">
            {content}
          </Text>
        )}
      </div>

      {relatedProjects.length > 0 && (
        <div className="flex flex-col md:flex-row flex-wrap items-center justify-center">
          {relatedProjects.map(project => (
            <AppLink
              key={project.uid}
              to={project.url}
              title={project.name}
              className="block p-3 m-2"
            >
              <img
                src={project.image.url}
                alt={project.name}
                width={project.image.width || undefined}
                height={project.image.height || undefined}
                className="block w-auto h-12 max-w-full object-contain"
                loading="lazy"
              />
            </AppLink>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommunityHome;
